module.exports = {
  referFriendComponentEvents: {
    ReferFriendLanding: {
      code: 'LANDING',
      events: {
        CopyLink: {
          description: 'Triggers when user copies referral link',
          eventHub: {
            code: 'COPY',
            action: 'ReferAFriendDesktop_Clicked Copy link'
          }
        },
        ShareLink: {
          description: 'Triggers when user clicks on share button on referral link.',
          eventHub: {
            code: 'SHARE',
            action: 'ReferAFriendMobile_Clicked Share'
          }
        }
      }
    }
  }
};
